module.exports = __webpack_public_path__ + "static/krakow-dc73a8c7352944cfeca12f1d00b8fc1f.png";